import React from 'react';
import { ActionButtonProps } from '../../types/general/TActionButtonProps';

const DeleteButton: React.FC<ActionButtonProps> = ({
    fill,
    id,
    actionHandler,
    disabled,
}) => {
    return (
        <svg
            onClick={disabled ? () => {} : () => actionHandler(id)}
            className="w-5 h-5 text-[#6b7280] cursor-pointer"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path d="M5.5 5.5h13v1h-13v-1Zm2 3h1v10h-1v-10Zm3 0h1v10h-1v-10Zm3 0h1v10h-1v-10ZM8 4h8v1H8V4ZM9 2h6v1H9V2ZM4 6h16v1H4V6ZM6 7h12v13a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7Z" />
        </svg>
    );
};

export default DeleteButton;
